import { ImageQueryResponse } from "@jmc/core/src/types/ImageQueryReponse";
import { ImagePosition } from "@jmc/solid-design-system/src/components/molecules/Card/Card";
import { Variant } from "@jmc/solid-design-system/src/components/molecules/HeaderHero/HeaderHero";

import { AccessLevel } from "./AccessLevel";
import { CMSBlock } from "./CMSBlock";
import { CMSFootnotes } from "./CMSFootnotes";
import { CMSHeroProps } from "./CMSHeroProps";
import { CMSMinisite } from "./CMSMinisite";
import { CMSSeoSettings } from "./CMSSeoSettings";

export const enum HeaderImageSize {
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
    XSmall = "X-Small",
}

export const enum HeaderVisualSource {
    Carousel = "Carousel",
    Colored_background = "Colored background",
    Hero = "Hero component",
    Image = "Image",
    Inherit = "Inherit from site settings",
    None = "None  (no header on this page)",
}

export interface CMSPage {
    page_title: string;
    seo_settings: CMSSeoSettings;
    id: string;
    uid: string;
    url: string;
    locale: string;
    header_visual?: {
        header_visual_source: HeaderVisualSource;
        header_image_size: HeaderImageSize;
        header_hero: CMSHeroProps[];
        carousel: Array<object>;
        header_image_from_file?: ImageQueryResponse;
        image_focus?: {
            image_focus: ImagePosition;
        };
        background_color?: string;
        variant?: Variant;
    };
    site_reference: CMSMinisite[];
    imr_number?: string;
    updated_at: string;
    created_at: string;
    content: CMSBlock[];
    access_control: {
        access_level: AccessLevel;
    };
    fields: {
        footnotes: CMSFootnotes[];
    };
    display_options?: {
        show_toc?: boolean;
        background_color: string;
    };
    hide_in_search?: boolean;
    publish_details: {
        locale: string;
    };
    service_name?: "recipes" | "ask-the-expert" | "contact-request" | "glossary" | "search";
}

export interface Footnotes {
    textual_content: string;
    text: string;
    footnotes: { number: number; text: string; item: string }[];
}
